// CommitteesSection.tsx
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay, A11y } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "./index.css";
import { useEffect, useRef, useState } from "react";

const committees = [
  {
    name: "DISEC",
    agenda:
      "Addressing the Challenges of Regulating Autonomous Weapons Systems.",
    logo: "/assets/images/OxfordMunNew/DISEC.png",
    link: "#oxford-mun-form",
  },
  {
    name: "SOCHUM",
    agenda:
      "Advancing Solutions for Combating Human Trafficking and Modern Slavery.",
    logo: "/assets/images/OxfordMunNew/SOCHUM.png",
    link: "#oxford-mun-form",
  },
  {
    name: "WHO",
    agenda: "Strengthening Global Preparedness for Future Pandemics.",
    logo: "/assets/images/OxfordMunNew/WHO.png",
    link: "#oxford-mun-form",
  },
  {
    name: "UNCSW",
    agenda: "Strengthening Global Efforts to Combat Gender-Based Violence.",
    logo: "/assets/images/OxfordMunNew/UNCSW.png",
    link: "#oxford-mun-form",
  },
  {
    name: "UNCOPUOS",
    agenda: "Enhancing Global Regulation of Space Debris Management.",
    logo: "/assets/images/OxfordMunNew/UNCOPOUS.png",
    link: "#oxford-mun-form",
  },
  {
    name: "UNESCO",
    agenda:
      "Promoting Equitable Access to Education Through Digital Transformation.",
    logo: "/assets/images/OxfordMunNew/UNESCO.png",
    link: "#oxford-mun-form",
  },
  {
    name: "UNEP",
    agenda:
      "Disproportionate Effect of Climate Change on Developing Countries.",
    logo: "/assets/images/OxfordMunNew/UNEP.png",
    link: "#oxford-mun-form",
  },
  {
    name: "UNHRC",
    agenda: "The Right to Privacy in the Digital Age.",
    logo: "/assets/images/OxfordMunNew/UNHRC.png",
    link: "#oxford-mun-form",
  },
  // Add more committees as needed
];

export default function CommitteesSection({
  handleModal = () => {},
  isMobile,
}) {
  const swiperRef = useRef(null);
  const [currentSlide, setCurrentSlide] = useState(1);
  const totalSlides = committees.length;
  const navConfig = {
    prevEl: `.swiper-button-prev-${isMobile ? "mobile" : "desktop"}-committees`,
    nextEl: `.swiper-button-next-${isMobile ? "mobile" : "desktop"}-committees`,
  };

  // 🔁 When `isMobile` changes, re-bind swiper navigation
  useEffect(() => {
    if (swiperRef.current && swiperRef.current.params?.navigation) {
      const swiper = swiperRef.current;

      swiper.params.navigation.prevEl = navConfig.prevEl;
      swiper.params.navigation.nextEl = navConfig.nextEl;

      swiper.navigation.destroy();
      swiper.navigation.init();
      swiper.navigation.update();
    }
  }, [isMobile]);

  return (
    <section className="committees-section">
      <div className="container">
        <div className="committees-header">
          <h2 className="committees-title">Committees and Agendas</h2>
          <img
            src="/assets/images/OxfordMUN-India-2025-Logo.png"
            alt="OxfordMun_logo"
            className="committees-mun-logo"
          />
        </div>
        {/* Custom Bottom Controls */}
        <div className="custom-bottom-nav-mobile">
          <div className="custom-arrow swiper-button-prev-mobile-committees">
            &#8592;
          </div>
          <div className="slide-counter">
            {currentSlide} / {totalSlides}
          </div>
          <div className="custom-arrow swiper-button-next-mobile-committees">
            &#8594;
          </div>
        </div>
        <Swiper
          onSwiper={(swiper) => {
            swiperRef.current = swiper;
          }}
          breakpoints={{
            // 1440: { slidesPerView: 4, spaceBetween: 40 },
            1024: { slidesPerView: 3, spaceBetween: 30 },
            900: { slidesPerView: 2, spaceBetween: 20 },
            768: { slidesPerView: 1, spaceBetween: 10 },
          }}
          modules={[Navigation, Autoplay, A11y]}
          // navigation
          navigation={navConfig}
          onInit={(swiper) => {
            swiper.params.navigation.prevEl = navConfig.prevEl;
            swiper.params.navigation.nextEl = navConfig.nextEl;
            swiper.navigation.init();
            swiper.navigation.update();
          }}
          onSlideChange={(swiper) => {
            setCurrentSlide(swiper.realIndex + 1);
          }}
          autoplay={{ delay: 5000, pauseOnMouseEnter: true }}
          loop
        >
          {committees.map((item, index) => (
            <SwiperSlide key={index}>
              <div className="committee-card">
                <img
                  src={item.logo}
                  alt={item.name}
                  className="committee-logo"
                />
                <h5 className="committee-name">{item.name}</h5>
                <div className="committee-desc">
                  <p className="committee-agenda">{item.agenda}</p>
                  <a onClick={handleModal} className="apply-btn">
                    Apply Now
                  </a>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
        {/* Custom Bottom Controls */}
        <div className="custom-bottom-nav">
          <div className="custom-arrow swiper-button-prev-desktop-committees">
            &#8592;
          </div>
          <div className="slide-counter">
            {currentSlide} / {totalSlides}
          </div>
          <div className="custom-arrow swiper-button-next-desktop-committees">
            &#8594;
          </div>
        </div>
      </div>
    </section>
  );
}
